<svg
  width="28"
  height="29"
  viewBox="0 0 28 29"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M23.861 15.542C23.5369 18.5869 21.8116 21.4403 18.9568 23.0885C14.2137 25.8269 8.1488 24.2018 5.41039 19.4587L5.11872 18.9536M4.13605 13.4587C4.46016 10.4138 6.18541 7.5605 9.04023 5.91227C13.7833 3.17386 19.8482 4.79895 22.5866 9.54202L22.8783 10.0472M4.07422 21.5773L4.92828 18.3899L8.11567 19.244M19.8815 9.75671L23.0688 10.6108L23.9229 7.42338M13.9986 9.25035V14.5004L16.9152 16.2504"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
